import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  parseToThousandSeperatorWholeNumber,
  formatCurrency,
} from "../../../shared/utility";
const KpiTable = ({ data }) => {
  const getTextClass = (value) =>
    value < 0 ? "text-red" : value > 0 ? "text-purple" : "";

  return (
    <Row className="m-0 bg-transparent">
      <Col md={12}>
        {/* Header */}
        <Row className="fw-bold border-bottom py-2">
          <Col md={2}>
            <span className="predefinded-audit-label">Metric</span>
          </Col>
          <Col md={3} className="text-center">
            <span className="predefinded-audit-label">Expected Value</span>
          </Col>
          <Col md={2} className="text-center">
            <span className="predefinded-audit-label">Counted</span>
          </Col>
          <Col md={2}>
            <span className="predefinded-audit-label">Discrepancy</span>
          </Col>
          <Col md={3} className="text-center">
            <span className="predefinded-audit-label">Discrepancy %</span>
          </Col>
        </Row>
        {/* Data Rows */}
        {data?.map((item, idx) => (
          <Row key={idx} className="py-2 border-bottom align-items-center">
            <Col md={2}>{item?.metric}</Col>
            <Col md={3} className="text-center">
              {item?.metric === "Quantity"
                ? parseToThousandSeperatorWholeNumber(item?.expected)
                : formatCurrency(item?.expected?.toFixed(2))}
            </Col>
            <Col md={2} className="text-center">
              {item?.metric === "Quantity"
                ? parseToThousandSeperatorWholeNumber(item?.counted)
                : formatCurrency(item?.counted?.toFixed(2))}
            </Col>
            <Col
              md={2}
              className={`text-center ${getTextClass(item?.discrepancy)}`}
            >
              {item?.metric === "Quantity"
                ? parseToThousandSeperatorWholeNumber(item?.discrepancy ?? 0)
                : formatCurrency(item?.discrepancy ?? 0)}
            </Col>
            <Col
              md={3}
              className={`text-center ${getTextClass(item?.discrepancy)}`}
            >
              {item?.discrepancyPercent ?? 0}
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
};

export default KpiTable;
